/** Reads the authenticated shop's pricing link independently of its TestFeed workspace connection. */
import { useQuery } from '@tanstack/react-query'
import { useShopifyAppContext } from '../ShopifyAppContext'
import { shopifyApiFetch, type ShopifyAppBridge } from '../shopifyApiFetch'

export function useShopifyPlanSelectionUrl(shopify: ShopifyAppBridge, enabled: boolean) {
  const { shopDomain } = useShopifyAppContext()
  return useQuery({
    queryKey: ['shop', shopDomain, 'plan-selection'],
    enabled: enabled && !!shopDomain && shopDomain !== 'no-shop',
    staleTime: 300_000,
    queryFn: async () => {
      const response = await shopifyApiFetch(shopify, '/api/testfeed-usage/plan-selection')
      if (!response.ok) throw new Error('Unable to load subscription management link')
      const result = (await response.json()) as { planSelectionUrl?: unknown }
      if (typeof result.planSelectionUrl !== 'string') throw new Error('Invalid subscription management link')
      return result.planSelectionUrl
    },
  })
}
